import React, {RefObject, useState, useEffect} from "react";
import {Video, VideoSlide} from "src/common/video/models/Video";
import {VideoCaptionTrack} from "src/common/video/models/VideoCaption";
import styles from "./TwoSplitVideoPlayer.module.css";
import {Document, Page, pdfjs} from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import "../../../../pages/vod/video/reactPdf.css";
import VideoMenu from "../../../../common/components/videoMenu/VideoMenu";
import VideoCommentPanel from "../comments/VideoCommentPanel";
import VideoSuggestionsPanel from "../suggestions/VideoSuggestionsPanel";
import VideoDocument from "../../../../pages/vod/Common/VideoDocument";
import VideoInfoPanel from "../metaData/VideoInfoPanel";
import EditVideoTab from "src/components/EditVideo";
// import { Swiper, SwiperSlide } from "swiper/react";
import {useSelector} from "react-redux";
import {AppState} from "src/root/RootReducer";
import PuiTypography from "../../../../components/elements/PuiTypography";
import PuiMessage from "../../../../components/widgets/PuiMessage";
import SlidePlayButton from "../../../../common/components/images/SlidePlayButton";
import SlidePlayButtonFocus from "../../../../common/components/images/SlidePlayButtonFocus";
import SlideBackButton from "../../../../common/components/images/SlideBackButton";
import SlideBackButtonFocus from "../../../../common/components/images/SlideBackButtonFocus";
import {Resizable} from "re-resizable";
import VideoReactions from "./reactions/VideoReactions";
import {css} from "@emotion/css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface TwoSplitVideoPlayerProps {
  video: Video;
  videoRef: RefObject<HTMLVideoElement>;
  currentVideoTimeMs: number;
  // セレクトエリア用コールバック関数
  onCallback?: any;
  subtitles: VideoCaptionTrack[];
  ClickVideo: (event: any) => void;
}

function TwoSplitVideoPlayer({
    video,
    videoRef,
    currentVideoTimeMs,
    subtitles,
    ClickVideo
}: TwoSplitVideoPlayerProps) {

    const {videoPdf,  videoOption} = useSelector(
        (state: AppState) => ({
            videoPdf: state.video.videoPdf,
            videoOption: state.exVideo.videoOption
        })
    );



    // 再生表示パターン切り替え時に再生時間を保持する
    useEffect(() => {
    // 視聴時間の上書きを防ぐ
        if (videoRef.current && currentVideoTimeMs > 0) {
            videoRef.current.currentTime = Math.floor(currentVideoTimeMs / 1000);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ビデオURL
    const sourceUrl =  video.sourceUrl;
    const [msg, setMsg] = React.useState<string>("");
    const closeMsg = () => {
        setMsg("");
    };

    const videoDownloadControl = document.getElementById("videoPlayer");
    if (videoDownloadControl) {
        videoDownloadControl.oncontextmenu = function () {
            return false;
        };
    }

    const [slideClicked, setSlideClicked] = useState(false);
    const [isPlayFocus, setIsPlayFocus] = useState<boolean>(false);
    const [isBackFocus, setIsBackFocus] = useState<boolean>(false);
    // eslint-disable-next-line
  const [numPages, setNumPages] = useState<number>(1);
    const [clickedPage, setClickPage] = useState<number>(1);
    const [activePage, setActivePage] = useState<number>(-1);
    const [videoSlides, setVideoSlides] = useState<VideoSlide[]>([]);

    function onDocumentLoadSuccess({numPages}) {
        setNumPages(numPages);
    }

    // ビデオの視聴時間を監視(1秒ごと)
    useEffect(() => {
        if (!videoPdf) return;
        changeActiveSlide();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentVideoTimeMs, videoPdf]);
    //}, [currentVideoTimeMs]);

    // スライド一覧表示フィルダ
    useEffect(() => {
        const tempList = [];
        if (videoPdf?.videoSlides) {
            for (let index = 0; index < videoPdf?.videoSlides.length; index++) {
                const element = videoPdf?.videoSlides[index];
                // スライド時間を設定しているか
                if (element.startMillis >= 0) {
                    tempList.push(element);
                }
            }
            setVideoSlides(tempList);
        }
    }, [videoPdf]);

    // スライド一覧をクリック時
    // const handleChangeSlide = (swiper: any) => {
    //   const currentSlide = swiper.clickedSlide;
    //   if (!currentSlide) return;
    //   const page = currentSlide.firstElementChild;
    //   const pageNum = page.getAttribute("data-page-number");
    //   setSlideClicked(true);
    //   setClickPage(Number(pageNum));
    // };

    // 再生中のスライド設定(1秒ごと)
    function changeActiveSlide() {
        for (let index = 0; index < videoSlides.length; index++) {
            const element = videoSlides[index];
            // 最後の一枚
            if (index + 1 === videoSlides.length) {
                setActivePage(element.slideId);
            }
            // 再生時間と設定時間との比較
            if (currentVideoTimeMs < element.startMillis) {
                // 最初の一枚
                if (index === 0) {
                    setActivePage(1);
                } else {
                    const preNum = videoSlides[index - 1].slideId;
                    setActivePage(preNum);
                }
                break;
            }
        }
    }

    // 再生中のスライドへ移動
    function changeCurrentSlide() {
        for (let index = 0; index < videoSlides.length; index++) {
            const element = videoSlides[index];
            // 最後の一枚
            if (index + 1 === videoSlides.length) {
                setActivePage(element.slideId);
            }
            // 再生時間と設定時間との比較
            if (currentVideoTimeMs < element.startMillis) {
                // 最初の一枚
                if (index === 0) {
                    setActivePage(1);
                    setSlideClicked(false);
                } else {
                    const preNum = videoSlides[index - 1].slideId;
                    setActivePage(preNum);
                    setSlideClicked(false);
                }
                break;
            }
        }
    }

    // スライドに合わせてビデオ秒数を設定
    function changeCurrentTime(slideNum: string) {
        for (let index = 0; index < videoSlides.length; index++) {
            const element = videoSlides[index];
            if (String(element.slideId) === slideNum) {
                console.log("changeCurrentTime:", element.startMillis / 1000);
                setActivePage(element.slideId);
                if (videoRef.current)
                    videoRef.current.currentTime = element.startMillis / 1000;
            }
        }
        setSlideClicked(false);
    }

    // スライド一覧のページ移動
    // function previousPage() {
    //   setClickPage(clickedPage - 1);
    // }
    // function nextPage() {
    //   setClickPage(clickedPage + 1);
    // }

    // スライドエリアの表示
    function handleShowSlide() {
        if (slideClicked) {
            return clickedPage;
        } else {
            if (activePage > 0) return activePage;
            return 1;
        }
    }

    const [resizeIcon, showResizeIcon] = useState(false);




    // スライド一覧のページ移動
    // function previousPage() {
    //   setClickPage(clickedPage - 1);
    // }
    // function nextPage() {
    //   setClickPage(clickedPage + 1);
    // }




    return (
        <>
            <div className={styles.videoArea}>
                <Resizable
                    defaultSize={{
                        width:"66.67%"
                    }}
                    className={styles.player}
                    onResizeStart={(e, direction, ref) => {
                        showResizeIcon(true);
                    }}
                    onResizeStop={(e, direction, ref, d) => {
                        showResizeIcon(false);
                    }}
                    enable={{
                        top: false,
                        right: true,
                        bottom: false,
                        left: false,
                        topRight: false,
                        bottomRight: false,
                        bottomLeft: false,
                        topLeft: false
                    }}
                >
                    <div className={css`
            position: relative;
            flex:1;
          `}
                    >
                        {(
                            <video
                                id="videoPlayer"
                                className={styles.videoPlayer}
                                controls
                                width={"100%"}
                                height={"100%"}
                                disablePictureInPicture
                                autoPlay
                                muted={videoOption.isMuted}
                                ref={videoRef}
                                key={sourceUrl} // Needed to inform React of source changes.
                                controlsList="nodownload"
                                style={{display: "block"}}
                                onClick={ClickVideo}
                            >
                                <source src={sourceUrl} type="video/mp4"/>
                                {subtitles.map(subtitle => (
                                    <track
                                        key={subtitle.id}
                                        kind="subtitles"
                                        srcLang={subtitle.srcLang}
                                        label={subtitle.label}
                                        src={subtitle.src}
                                    />
                                ))}
                            </video>
                        ) }
                    </div>

                    {/* ビデオリアクション */}
                    <VideoReactions
                        reactions={video.reactions}
                        videoId={video.id}
                        videoDuration={video.durationMillis}
                        videoRef={videoRef}
                        video={video}
                    />
                    <div className={styles.editVideoIcon}>
                        <EditVideoTab video={video}/>
                    </div>
                    {/* {videoPdf !== undefined && (
            <VideoPageBar
              pdf={videoPdf}
              videoSlides={videoSlides}
              videoDuration={video.durationMillis}
              currentVideoTimeMs={
                videoRef.current
                  ? videoRef.current.currentTime * 1000
                  : currentVideoTimeMs
              }
              videoRef={videoRef}
            />
          )} */}

                    <div className={styles.resizeIcon} hidden={!resizeIcon}></div>
                </Resizable>
                <div className={styles.slideArea}>
                    <div className={css`
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
          `}
                    >
                        {videoPdf !== undefined && (
                            <Document
                                file={videoPdf.slideUrl}
                                onLoadSuccess={onDocumentLoadSuccess}
                                options={{
                                    cMapUrl: `https://unpkg.com/pdfjs-dist@${pdfjs.version}/cmaps/`,
                                    cMapPacked: true
                                }}
                            >
                                <Page
                                    pageNumber={handleShowSlide()}
                                    className={styles.pdfView}
                                    renderAnnotationLayer={false}
                                />
                                <div
                                    className={styles.pdfConArea}
                                    style={
                                        slideClicked
                                            ? {visibility: "visible"}
                                            : {visibility: "hidden"}
                                    }
                                >
                                    <div
                                        className={styles.pdfButtonArea}
                                        onClick={() => changeCurrentSlide()}
                                        onMouseEnter={() => setIsBackFocus(true)}
                                        onMouseLeave={() => setIsBackFocus(false)}
                                    >
                                        {!isBackFocus && <SlideBackButton/>}
                                        {isBackFocus && <SlideBackButtonFocus/>}
                                    </div>
                                    <div
                                        className={styles.pdfButtonArea}
                                        onClick={() => changeCurrentTime(String(clickedPage))}
                                        onMouseEnter={() => setIsPlayFocus(true)}
                                        onMouseLeave={() => setIsPlayFocus(false)}
                                    >
                                        {!isPlayFocus && <SlidePlayButton/>}
                                        {isPlayFocus && <SlidePlayButtonFocus/>}
                                    </div>
                                </div>
                            </Document>
                        )}
                    </div>
                </div>
            </div>
            <div className={styles.menu}>
                <VideoMenu video={video} setMsg={setMsg}/>
            </div>

            <div className={styles.meta}>
                <div className={styles.metaLeft}>
                    <VideoInfoPanel video={video}/>

                    <div className={styles.materials}>
                        <VideoDocument documentList={video.extraMaterials}/>
                    </div>

                    <div className={styles.comments}>
                        <VideoCommentPanel
                            comments={video.comments}
                            videoId={video.id}
                            videoRef={videoRef}
                        />
                    </div>
                </div>
                <div className={styles.metaRight}>
                    <VideoSuggestionsPanel videoId={video.id}/>
                </div>

                <PuiMessage
                    open={msg !== ""}
                    type="success"
                    title="登録に成功しました"
                    detail={[<PuiTypography key={msg}>{msg}</PuiTypography>]}
                    duration={6000}
                    onClose={closeMsg}
                />
            </div>


        </>
    );
}

export default TwoSplitVideoPlayer;
